import { TrackingPageModel } from '../tracking-page.model';
import {
  getAsset,
  getFontConfig,
  getSocialIcons,
  getFooterItems,
  getLogo,
  getLanguageMenu,
  white,
  getProductItems
} from './helpers';

export const tourism: TrackingPageModel = {
  languageMenu: getLanguageMenu('Quicksand', '#d67a0aff', '700'),
  searchPageInput: {
    backgroundColor: '#ffffff',
    borderColor: '#ced4da',
    borderRadius: 22,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Ubuntu', '#6d788c')
  },
  searchPageTitle: {
    fontSize: 18,
    ...getFontConfig('Rubik', '#884414ff', '700')
  },
  background: {
    color: white,
    useBackgroundImage: true,
    imageUrl: getAsset('/images/themes/tourism.png'),
    backgroundMode: 'cover',
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat'
  },
  card: {
    backgroundColor: '#ffffff',
    linksColor: '#5780ff',
    linksUnderline: false,
    headerBackground: '#ffffff',
    footerBackground: '#ffffff',
    borderColor: '#ffffffff',
    borderRadius: 4,
    borderWidth: 1,
    shadow: 'none',
    trackingNumberField: 'trackingNumber',
    ...getFontConfig('Quicksand', '#683f2eff')
  },
  orderCard: {
    backgroundColor: '#ffffff',
    linksColor: '#5780ff',
    linksUnderline: false,
    headerBackground: '#ffffff',
    footerBackground: '#ffffff',
    borderColor: '#e1b910ff',
    borderRadius: 25,
    borderWidth: 2,
    shadow: 'none',
    ...getFontConfig('Ubuntu', '#2E4068')
  },
  orderNumber: {
    alignment: 'center',
    fontSize: 21,
    ...getFontConfig('Kanit', '#654132ff')
  },
  orderStatus: {
    alignment: 'center',
    fontSize: 21,
    ...getFontConfig('Quicksand', '#426532ff', '700')
  },
  orderLastUpdated: {
    alignment: 'center',
    fontSize: 15,
    ...getFontConfig('Quicksand', '#626262ff')
  },
  notYetShippedItemsTitle: {
    alignment: 'center',
    fontSize: 25,
    ...getFontConfig('Quicksand', '#de7415ff', '700')
  },
  orderStatusOn: true,
  orderNumberOn: true,
  orderLastUpdatedOn: true,
  orderItemsFrame: {
    on: true,
    scroll: false,
    itemsLimit: 4,
    borderColor: '#f5b724ff',
    borderWidth: 1,
    borderRadius: 16,
    backgroundColor: '#ffffff',
    shadow: null,
    button: {
      on: true,
      backgroundColor: '#37a611ff',
      borderColor: '#607ff7ff',
      borderRadius: 22,
      borderWidth: 0,
      shadow: 'none',
      ...getFontConfig('Quicksand', '#ffffffff', '700')
    },
    itemCard: {
      backgroundColor: '#ffffff',
      borderColor: '#ffffff',
      borderRadius: 16,
      borderWidth: 1,
      shadow: 'none',
      title: {
        alignment: 'left',
        fontSize: 20,
        ...getFontConfig('Quicksand', '#512513ff', '700')
      },
      info: {
        alignment: 'left',
        fontSize: 13,
        ...getFontConfig('Quicksand', '#653932ff', '500')
      },
      showAttributes: false
    }
  },
  searchButton: {
    on: true,
    backgroundColor: '#e59001ff',
    borderColor: '#ffffffff',
    borderRadius: 22,
    borderWidth: 2,
    shadow: 'none',
    ...getFontConfig('Quicksand', '#ffffffff', '700')
  },
  detailsButton: {
    backgroundColor: '#e77901ff',
    borderColor: '#5780ff',
    borderRadius: 22,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Ubuntu', white)
  },
  trackButton: {
    backgroundColor: '#ee7227',
    borderColor: '#ee7227',
    borderRadius: 22,
    borderWidth: 1,
    shadow: 'none',
    ...getFontConfig('Quicksand', white, '700')
  },
  pageScroll: {
    scrollColor: '#d78306ff',
    borderRadius: 4,
    backgroundColor: '#ffffff00'
  },
  scripts: {
    head: null,
    body: null
  },
  logo: getLogo(getAsset('/images/themes/tourism-logo.png')),
  socialIcons: getSocialIcons('#cf8303ff', true),
  sidebar: {
    parcelIcon: 'icon-parcel',
    groupIcon: 'icon-track_number',
    backgroundColor: '#ffffff',
    borderColor: '#e1b910ff',
    borderRadius: 20,
    borderWidth: 2,
    shadow: 'none',
    sidebarField: null,
    ...getFontConfig('Ubuntu', '#2E4068')
  },
  footer: {
    linksColor: '#ba2200ff',
    linksUnderline: false,
    backgroundColor: '#ffffff92',
    ...getFontConfig('Quicksand', '#9f3600ff', '500'),
    ...getFooterItems()
  },
  header: {
    backgroundColor: '#ffffff00'
  },
  faviconUrl: '/assets/favicon/favicon-32x32.png',
  sidebarProductsFeed: {
    on: false,
    backgroundColor: '#ffffffff',
    borderColor: '#e1b910ff',
    borderRadius: 25,
    borderWidth: 2,
    shadow: 'none',
    card: {
      backgroundColor: '#ffffff',
      borderColor: '#ffffff',
      borderRadius: 0,
      borderWidth: 0,
      shadow: 'none',
      button: {
        backgroundColor: '#40a50eff',
        borderColor: '#5780ff',
        borderRadius: 22,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Quicksand', white, '700')
      },
      buttonText: 'BUY NOW',
      title: {
        alignment: 'center',
        fontSize: 15,
        ...getFontConfig('Quicksand', '#000000ff', '500')
      },
      regularPrice: {
        alignment: 'center',
        fontSize: 10,
        ...getFontConfig('Quicksand', '#2f1717ff')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 20,
        ...getFontConfig('Quicksand', '#f68700ff', '600')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('tourism'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#d66a0bff',
      arrowSize: 35
    }
  },
  mainProductsFeed: {
    on: true,
    backgroundColor: '#ffffffff',
    borderColor: '#e1b910ff',
    borderRadius: 25,
    borderWidth: 2,
    shadow: 'none',
    card: {
      backgroundColor: '#ffffff',
      borderColor: '#ffffff',
      borderRadius: 0,
      borderWidth: 0,
      shadow: 'none',
      button: {
        backgroundColor: '#40a50eff',
        borderColor: '#5780ff',
        borderRadius: 22,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Quicksand', white, '700')
      },
      buttonText: 'BUY NOW',
      title: {
        alignment: 'center',
        fontSize: 15,
        ...getFontConfig('Quicksand', '#000000ff', '500')
      },
      regularPrice: {
        alignment: 'center',
        fontSize: 10,
        ...getFontConfig('Quicksand', '#2f1717ff')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 20,
        ...getFontConfig('Quicksand', '#f68700ff', '600')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('tourism'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#d66a0bff',
      arrowSize: 35
    }
  },
  seoTitle: ''
};
